import { toString30pk9tzaqopn as toString } from './Library.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.bf_1 = first;
        this.cf_1 = second;
      }
      toString() {
        return '(' + toString(this.bf_1) + ', ' + toString(this.cf_1) + ')';
      }
      df() {
        return this.bf_1;
      }
      ef() {
        return this.cf_1;
      }
      it(first, second) {
        return new (Pair())(first, second);
      }
      jt(first, second, $super) {
        first = first === VOID ? this.bf_1 : first;
        second = second === VOID ? this.cf_1 : second;
        return $super === VOID ? this.it(first, second) : $super.it.call(this, first, second);
      }
      hashCode() {
        var result = this.bf_1 == null ? 0 : hashCode(this.bf_1);
        result = imul(result, 31) + (this.cf_1 == null ? 0 : hashCode(this.cf_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.bf_1, other.bf_1))
          return false;
        if (!equals(this.cf_1, other.cf_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.kt_1 = first;
        this.lt_1 = second;
        this.mt_1 = third;
      }
      toString() {
        return '(' + toString(this.kt_1) + ', ' + toString(this.lt_1) + ', ' + toString(this.mt_1) + ')';
      }
      hashCode() {
        var result = this.kt_1 == null ? 0 : hashCode(this.kt_1);
        result = imul(result, 31) + (this.lt_1 == null ? 0 : hashCode(this.lt_1)) | 0;
        result = imul(result, 31) + (this.mt_1 == null ? 0 : hashCode(this.mt_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.kt_1, other.kt_1))
          return false;
        if (!equals(this.lt_1, other.lt_1))
          return false;
        if (!equals(this.mt_1, other.mt_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
